// Shell de páginas de contenido (no-landing): reusa el Navbar y Footer reales
// en modo "contenido" (links que vuelven al landing, sin scroll-spy) y compensa
// el alto del navbar fijo. El landing NO usa este layout (su Hero ya aporta el
// offset); ver app/Landing.tsx.

import type { ReactNode } from 'react';
import { Navbar } from '@/sections/Navbar/Navbar';
import { Footer } from '@/sections/Footer/Footer';
import styles from './PageLayout.module.css';

export function PageLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <Navbar />
      <main className={styles.main}>{children}</main>
      <Footer />
    </>
  );
}
